import { render, staticRenderFns } from "./UserSets.vue?vue&type=template&id=55b16a81&"
import script from "./UserSets.vue?vue&type=script&lang=js&"
export * from "./UserSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports